import React from "react";
import "./Loader.css";

const Loader = () => {
  return (
    <>
      <div className="loader-container">
        <div className="loader">
          <span></span>
        </div>
        <div className="loader">
          <span></span>
        </div>
      </div>
    </>
  );
};

export default Loader;
